import type { TGetListaOportunidadesParams } from '@/http/get-lista-oportunidades-chile.service'

export const oportunidadesChileKeys = {
  oportunidade: ['oportunidades-chile'] as const,
  lista: (params: TGetListaOportunidadesParams, t: string) =>
    [...oportunidadesChileKeys.oportunidade, 'lista', params, t] as const,
}
